// @flow
import type { Thunk } from 'app/common/redux/types';
import wait from 'app/common/lib/wait';

export type ResetLoadingBar = {
  type: 'RESET_LOADING_BAR',
};

export function pageBundleLoadComplete(): Thunk<void> {
  return (dispatch, getState) => {
    // wait to see if any resources start fetching
    wait(250).then(() => {
      // if no resource fetches have started, we can't
      // rely on a resource complete action to reset the state
      if (getState().loadingBar && getState().loadingBar.resourcesFetching === 0) {
        dispatch({
          type: 'RESET_LOADING_BAR',
        });
      }
    });
  };
}

export default undefined;
